import * as z from "zod/v4";

export const getCustomerTags = {
  name: "getCustomerTags" as const,
  input: z.null(),
  output: z.object({ tags: z.array(z.string()) }),
};
